import React from 'react';
import CurationRestaurantItemSkeleton from './CurationRestaurantItemSkeleton';

/**
 * 큐레이션 카드 스켈레톤 컴포넌트
 * 실제 CurationCard와 동일한 구조로 스켈레톤 생성
 */
const CurationCardSkeleton: React.FC = () => {
  return (
    <div className="mb-6">
      {/* 카테고리 헤더 스켈레톤 */}
      <div className="flex items-center justify-between mb-4 px-4">
        {/* 카테고리 제목 스켈레톤 */}
        <div className="h-6 bg-gray-200 rounded animate-pulse w-48"></div>
        
        {/* 더보기 버튼 스켈레톤 */}
        <div className="h-4 bg-gray-200 rounded animate-pulse w-12"></div>
      </div>
      
      {/* 레스토랑 목록 horizontal scroll 스켈레톤 */}
      <div className="flex gap-3 overflow-hidden px-4">
        {/* 3개의 레스토랑 카드 스켈레톤 */}
        <CurationRestaurantItemSkeleton />
        <CurationRestaurantItemSkeleton />
        <CurationRestaurantItemSkeleton />
      </div>
    </div>
  );
};

export default CurationCardSkeleton; 